<template>
    <div>
        <v-container fluid grid-list-xl class="home-container general-container">
            <v-layout row wrap class="navigation-header">
                <v-flex xs12>
                    <header-bar></header-bar>
                </v-flex>
            </v-layout>


            <div class="scrolling-content padding-left-xxl padding-right-xxl">
            <v-layout class=" buttons">
                <v-btn   @click="getTestTreeModified"  class="footer-btn home margin-top-l modifiedTree btn-test-pg" v-if="getRunTestData && getResponseTestData === 200">
                    <span>{{text("api.pro.tests.getTestTree")}}</span>
                </v-btn>
                <v-btn   @click="getErrorsTree"  class="footer-btn home margin-top-l modifiedTree btn-test-pg" v-if="getRunTestData && getResponseTestData === 200 && getRunTestData.totalErrorNo > 0">
                    <span>{{text("api.pro.tests.getErrorsTree")}}</span>
                </v-btn>
                <v-btn   @click="getTestResult"  class="footer-btn home margin-top-l modifiedTree btn-test-pg" v-if="getRunTestData && getResponseTestData === 200" >
                    <span>{{text("api.pro.tests.getTestResult")}}</span>
                </v-btn>

                <v-btn @click="all" v-if="getRunTestData && getResponseTestData === 200 && !activepanels" class="footer-btn home margin-top-l modifiedTree expand">{{text("api.pro.expandPanels")}}</v-btn>
                <v-btn @click="no" v-if="getRunTestData && getResponseTestData === 200 && activepanels" class="footer-btn home margin-top-l modifiedTree expand">{{text("api.pro.collapsePanels")}}</v-btn>


            </v-layout>

            <v-layout row wrap >
                <v-flex xs12>


                        <div v-if="!getRunTestData && getResponseTestData !== undefined">
                            <v-progress-linear
                                :indeterminate="true"
                                color="primary"
                                class="margin-top-xxl"
                                height="10">
                            </v-progress-linear>
                            <span>Loading data...</span>
                        </div>

                        <div v-if=" getResponseTestData !== 200 && getRunTestData === null" class="margin-top-xxl">
                            {{getResponseTestData }}
                            <v-alert
                                :value="true"
                                type="error"
                                outline>
                                Error on loading data {{getResponseTestData }}
                            </v-alert>
                        </div>

                    <div v-if="getRunTestData && getResponseTestData === 200" class="results-info">
                        <span class="margin-left-s test-title">Total Results</span>
                        <div class="count-results-gen">
                            <span class="margin-left-l"> {{getRunTestData.totalSuccessNo}} <v-icon color="success">done</v-icon></span>
                            <span class="margin-left-m"> {{getRunTestData.totalInfoNo}} <v-icon color="info">info</v-icon></span>
                            <span class="margin-left-m"> {{getRunTestData.totalWarningNo}} <v-icon color="warning">warning</v-icon></span>
                            <span class="margin-left-m"> {{getRunTestData.totalErrorNo}} <v-icon color="error">error</v-icon></span>
                        </div>
                    </div>
                    <v-expansion-panel v-if="getRunTestData && getResponseTestData === 200" class="margin-bottom-xxl"
                                       expand v-model="panel">
                        <v-expansion-panel-content v-for="(testcase, i) in getRunTestData.testCaseList" :key="i"
                                                   class="expansion-list" v-model="panel[i]">
                            <div slot="header" class="color-headings-text font-size-medium section">
                                <span class="test-title">{{testcase.testResultLabel}}</span>
                                <div class="count-results-section">
                                    <span class="margin-left-l"> {{testcase.successNo}} <v-icon
                                        color="success">done</v-icon></span>
                                    <span class="margin-left-m"> {{testcase.infoNo}} <v-icon
                                        color="info">info</v-icon></span>
                                    <span class="margin-left-m"> {{testcase.warningNo}} <v-icon
                                        color="warning">warning</v-icon></span>
                                    <span class="margin-left-m"> {{testcase.errorNo}} <v-icon
                                        color="error">error</v-icon></span>
                                </div>
                            </div>

                            <v-card>
                                <v-card-text class="expansion-table">

                                    <v-data-table
                                        :items="testcase.testResultFlowDtoProV2.flowList"
                                        class="elevation-1"
                                        hide-actions
                                        hide-headers>
                                        <template slot="items" slot-scope="props">
                                            <table aria-describedby="Status table">
                                                <tr>
                                                    <th scope="col" class="name">Status</th>
                                                    <th scope="col" class="value boldstatus"
                                                        v-if="props.item.executionType === 'ERROR'">
                                                        {{ props.item.executionType }}
                                                        <v-icon color="error">error</v-icon>
                                                    </th>
                                                    <th scope="col" class="value boldstatus"
                                                        v-if="props.item.executionType === 'SUCCESS'">
                                                        {{ props.item.executionType }}
                                                        <v-icon color="success">done</v-icon>
                                                    </th>
                                                    <th scope="col" class="value boldstatus"
                                                        v-if="props.item.executionType === 'WARNING'">
                                                        {{ props.item.executionType }}
                                                        <v-icon color="warning">warning</v-icon>
                                                    </th>
                                                    <th scope="col" class="value boldstatus"
                                                        v-if="props.item.executionType === 'INFO'">
                                                        {{ props.item.executionType }}
                                                        <v-icon color="info">info</v-icon>
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <td class="text-xs-left name">Endpoint</td>
                                                    <td class="value"> {{ props.item.endpoint }}
                                                        <span class="btn-actions">
                                                            <span> <v-btn @click="isExpectedResponse(props.item.responseExpected)">expected</v-btn></span>
                                                            <span><v-btn  @click="isReceivedResponse(props.item.responseReceived)">received</v-btn></span>
                                                        </span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="text-xs-left name">Request</td>
                                                    <td class="value"> {{ props.item.request }} </td>
                                                </tr>

                                                <tr v-if="props.item.executionType !== 'SUCCESS'">
                                                    <td class="text-xs-left name">Diff <br/>
                                                        <v-btn v-bind:class="{required: isRequired}"
                                                               @click="acceptResponse(props, $event)" class="acceptBtn"
                                                               color="primary">Accept Receive/Response
                                                        </v-btn>
                                                    </td>
                                                    <td class="value test-results">

                                                        <tree-menu
                                                            :node="props.item.testResultNode"
                                                            :depth="0">
                                                        </tree-menu>

                                                    </td>
                                                </tr>
                                            </table>


                                        </template>
                                    </v-data-table>
                                </v-card-text>
                            </v-card>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-flex>
            </v-layout>
        </div>
        </v-container>


        <v-footer app class="elevation-bg-color">
            <v-layout row wrap class="padding-left-xxl padding-right-xxl">
                <v-flex xs12 text-xl-right text-lg-right text-md-right text-sm-right text-xs-right>

                    <v-btn flat color="grey darken-1" @click="goToPreviousPage" class="footer-btn home">
                        <v-icon>keyboard_arrow_left</v-icon>
                        {{ text('api.button.back') }}
                    </v-btn>

                </v-flex>
            </v-layout>
        </v-footer>

        <v-dialog  scrollable
                   width="70%"
                   v-model="isExpectedResponseData"
                   content-class="dialog-expected">
            <v-card style="height: 100%;">
                <v-card-text>
                    <div><pre>{{isExpectedResponseJson}}</pre></div>
                </v-card-text>

            </v-card>

        </v-dialog>
        <v-dialog  scrollable
                   width="70%"
                   v-model="isReceivedResponseData"
                   content-class="dialog-received">
            <v-card style="height: 100%;">
                <v-card-text>
                    <div><pre>{{isReceivedResponseJson}}</pre></div>
                </v-card-text>
            </v-card>

        </v-dialog>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import HeaderBar from '../shared/HeaderBar';
    import axios from 'axios';
    import TreeMenu from './TreeMenu';


    export default {
        name: "RunTestPage",
        components: {
            HeaderBar,
            TreeMenu

        },
        data () {
            return {
                isRequired: false,
                panel: [],
                panelpro: [],
                panelapi: [],
                panelapiv1: [],
                activepanels: false,
                isExpectedResponseJson: '',
                isReceivedResponseJson: '',
                isExpectedResponseData: false,
                isReceivedResponseData:false

            }
        },
        mounted () {
            this.$store.commit('TestStore/clearRunTestData');
        },
        created () {
            this.$store.dispatch('TestStore/runTest');
        },
        computed: {
            ...mapGetters({
                getRunTestData: 'TestStore/getRunTestData',
                getResponseTestData: 'TestStore/getResponseTestData'
            })
        },
        methods: {
            goToPreviousPage() {
                this.$router.push('/test-tree')
            },
            acceptResponse(props, $event) {

                let axiosRequest = axios.post(process.env.API_BASE_URL + '/test/acceptDiff', {
                    nodeId: props.item.nodeId
                });

                axiosRequest.then((response) => {
                    console.log(response);
                    console.log($event.target);
                    $event.target.classList.add('acceptDiff')
                });
                axiosRequest.catch((error) => {
                    console.log(error);
                });
            },

            getTestTreeModified() {
                console.log("download modified tree");
                axios({
                    url: process.env.API_BASE_URL + '/test/getTestTreeModified',
                    method: 'POST',
                    responseType: 'blob', // important
                }).then((response) => {
                    const testName = response.headers["file-name-value"];
                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveOrOpenBlob(new Blob([response.data]), testName); /* IE browser Solution*/
                    } else {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', testName);
                        document.body.appendChild(link);
                        link.click();
                    }
                });
            },
            getErrorsTree() {
                console.log("download modified tree");
                axios({
                    url: process.env.API_BASE_URL + '/test/getErrorTestCases',
                    method: 'POST',
                    responseType: 'blob', // important
                }).then((response) => {
                    const testName = response.headers["file-name-value"];
                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveOrOpenBlob(new Blob([response.data]), testName); /* IE browser Solution*/
                    } else {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', testName);
                        document.body.appendChild(link);
                        link.click();
                    }
                });
            },
            getTestResult() {
                console.log("download test result");
                axios({
                    url: process.env.API_BASE_URL + '/test/getTestResultFile',
                    method: 'POST',
                    responseType: 'blob', // important
                }).then((response) => {
                    const testName = response.headers["file-name-value"];
                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveOrOpenBlob(new Blob([response.data]), testName); /* IE browser Solution*/
                    } else {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', testName);
                        document.body.appendChild(link);
                        link.click();
                    }
                });
            },


            all () {
               this.panel = [...Array(this.getRunTestData.testCaseList.length).keys()].map(_ => true);
                this.panelpro = [...Array(this.getRunTestData.testCaseList.length).keys()].map(_ => true);
                this.panelapi = [...Array(this.getRunTestData.testCaseList.length).keys()].map(_ => true);
                this.panelapiv1 = [...Array(this.getRunTestData.testCaseList.length).keys()].map(_ => true);
               this.activepanels = !this.activepanels;
            },
            // Reset the panel
            no () {
                this.panel = [];
                this.panelpro = [];
                this.panelapi = [];
                this.panelapiv1 = [];
                this.activepanels = !this.activepanels;
            },
            toggleChildren() {
                this.showChildren = !this.showChildren;
            },
            isExpectedResponse(data){
                this.isExpectedResponseData = true;
                this.isExpectedResponseJson = data;
            },
            isReceivedResponse(data) {
                this.isReceivedResponseData = true;
                this.isReceivedResponseJson = data;
            }

        },
    }


</script>

<style lang="scss" scoped>

    table {
        margin-bottom: 20px;

    }

    .expansion-panel {

        .expansion-tables {
            padding: 2px;
            border: 1px solid lightgray;
            border-radius: 5px;
            margin-bottom: 10px;
        }
    }

    .expansion-table .elevation-1 {
           box-shadow: none !important;
    }

    .datatable table {
        border: 1px solid gray;
        margin-bottom: 20px;
        border-spacing: 0 !important;
        border-bottom: 0;
        width: 100%;

        td {
            font-size: $font-size-default;
            padding: 5px 24px !important;

            &.value {
                position: relative;
                padding:15px 5px !important;

                span.btn-actions {
                    position: absolute;
                    bottom: 3px;
                    right: 0;
                }
            }
        }
    }


    .name {
        border-right: 1px solid gray;
        font-weight: $font-weight-bold;
        width: 17%;
    }

    .boldstatus{
        font-weight: $font-weight-bold;
    }

    .name, .value {
        border-bottom: 1px solid gray;
    }

    .acceptBtn {
        margin-left: 0;
    }

    .modifiedTree {
        margin-left: 15px;
    }

    .icon {
        margin-bottom: 5px;
    }

    .test-title {
        min-width: 80px;
        float: left;
    }

    .results-info {
        font-weight: bold;
        font-size: $font-size-medium;
        padding: 10px;
        background-color: white;
        margin-bottom: 15px;
        border-radius: 7px;
        width: 100%;
        display: inline-block;
    }

    .count-results-gen {
        float: right;
        margin-right: 100px;
    }

    .count-results-section {
        float: right;
        margin-right: 55px;
    }

    .section {
        display: inline-block;
    }

    .count-results {
        float: right;
        margin-right: 25px;
    }

    .scrolling-content {
        top: 80px;
        position: fixed;
        margin-left: auto;
        margin-right: auto;
        bottom: 70px;
        overflow: auto;
        width: 100%;
        padding-top: 40px
    }

    .buttons {
        display: block;

        .expand {
            float: right;
            right: 5px;
        }

    }

    .datatable table td.test-results {
        padding-left: 0 !important;
    }

    .dialog-received .card, .dialog-expected .card {
        padding: 0 !important;
    }

    .dialog-received .pre, .dialog-expected .pre {
        // background-color: $color-lightest;
        color: $color-body-text;
    }

    .dialog-received pre, .dialog-expected pre {
        // background-color: $color-lightest;
        color: $color-body-text;
    }

</style>



// WEBPACK FOOTER //
// src/professional/components/tests/RunTestPage.vue